window.mcb.cookies = window.mcb.cookies || {};
window.mcb.cookies.checker = (function () {
    const _logger = window.mcb.utilities.createLogger('cookies.checker', 'Embed Checker');
    const main = document.querySelector('main');
    const initDelay = 50;
    let timer = undefined;

    const paint = function (sourced, sender = null) {
        if (sender !== null) {
            _logger.log('Checking ' + sourced.tagName + ' from ' + sender, sourced);
        }

        try {
            const source = sourced.dataset.src;
            delete sourced.dataset.src;

            // TODO: Check for Cookie Accept

            sourced.src = source;
        }
        catch (err) {
            _logger.error(err);
        }
    };

    const paintHolder = function (holder, sender = null) {
        if (sender !== null) {
            _logger.log('Checking ' + holder.tagName + ' from ' + sender, holder);
        }

        try {
            const source = holder.dataset.embedUrl ?? null;
            if (source !== null) {
                holder.classList.add('umb-embed-holder--treated');

                // TODO: Check for Cookie Accept

                var iframe = holder.querySelector('iframe');
                if (iframe !== null) {
                    iframe.src = source;
                }
            }
        }
        catch (err) {
            _logger.error(err);
        }
    };

    const applyChecker = function (sender) {
        main.querySelectorAll('[data-src]').forEach((sourced) => {
            paint(sourced, sender);
        });

        main.querySelectorAll('.umb-embed-holder:not(.umb-embed-holder--treated)').forEach((holder) => {
            paintHolder(holder, sender);
        });
    }

    const observer = new MutationObserver(function (mutations) {
        if (mutations.length > 0) {
            if (timer !== undefined) {
                clearTimeout(timer);
            }

            timer = setTimeout(function () {
                applyChecker('mutation');
            }, 100);
        }
    });

    observer.observe(main, { attributes: false, childList: true, characterData: false, subtree: true });

    setTimeout(applyChecker, initDelay);

    return {
        applyChecker: function () {
            applyChecker('manual');
        }
    }
})();
